import React from "react";
import { Switch, Route, BrowserRouter } from 'react-router-dom'
import './App.scss'

import Footer from "../Footer/Footer";
import News from "../News/News";
import Settings from "../Settings/Settings";
import Sidebar from "../Sidebar/Sidebar";
import UsersContainer from "../Users/UsersContainer";

import HeaderContainer from "../Header/HeaderContainer";
import { connect } from "react-redux";
import { initializeApp } from './../../redux/app-reducer'
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import Preloader from "../../common/Preloader/Preloader";
import store from '../../redux/redux-store'
import { Provider } from 'react-redux';
import withSuspense from "../../hoc/withSuspense";


const Chat = React.lazy(() => import("../Chat/Chat"))
const ProfileContainer = React.lazy(() => import("../Profile/ProfileContainer"))
const LoginContainer = React.lazy(() => import("../Login/LoginContainer"))



class App extends React.Component {

  componentDidMount = () => this.props.initializeApp()

  render() {
    if (!this.props.initialize) return <Preloader />
    return (
      <div className="app">
        <HeaderContainer />
        <div className="app-content">
          <Sidebar state={this.props.state.sidebar} />
          <main className="app-main">
            <Switch>
              <Route exact path="/" ><News /></Route>
              <Route path="/profile/:userId?" >
                {withSuspense(ProfileContainer, <Preloader />)}
              </Route>

              <Route exact path="/chat" >
                {withSuspense(Chat, <Preloader />, { state: this.props.state.dialogPage })}
              </Route>
              <Route path="/chat/:url" >
                {withSuspense(Chat, <Preloader />, { state: this.props.state.dialogPage })}
              </Route>

              <Route exact path="/news" ><News /></Route>
              <Route exact path="/users" ><UsersContainer /></Route>
              <Route exact path="/settings" ><Settings /></Route>
              <Route exact path="/login" >
                {withSuspense(LoginContainer, <Preloader />)}
              </Route>
            </Switch>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    initialize: state.app.initialized
  }
}

let AppContainer = compose(
  withRouter,
  connect(mapStateToProps, { initializeApp }))(App);


let MainApp = (props) => {

  return (
    <BrowserRouter>
      <Provider store={store}>
        <AppContainer state={store.getState()} />
      </Provider>
    </BrowserRouter>
  )
}

export default MainApp;